 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		var prefetchChunks = data[3] || [];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		deferredPrefetch.push.apply(deferredPrefetch, prefetchChunks);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		if(deferredModules.length === 0) {
 			// chunk prefetching for javascript
 			deferredPrefetch.forEach(function(chunkId) {
 				if(installedChunks[chunkId] === undefined) {
 					installedChunks[chunkId] = null;
 					var link = document.createElement('link');

 					if (__webpack_require__.nc) {
 						link.setAttribute("nonce", __webpack_require__.nc);
 					}
 					link.rel = "prefetch";
 					link.as = "script";
 					link.href = jsonpScriptSrc(chunkId);
 					document.head.appendChild(link);
 				}
 			});
 			deferredPrefetch.length = 0;
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [], deferredPrefetch = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"admin~app-category~layoutApp":"admin~app-category~layoutApp","admin~app-premium~auth":"admin~app-premium~auth","admin":"admin","app-category":"app-category","layoutApp":"layoutApp","app-premium":"app-premium","auth":"auth","app-about":"app-about","app-card":"app-card","app-contact":"app-contact","app-container":"app-container","app-getstarted":"app-getstarted","app-helphome":"app-helphome","app-home":"app-home","install":"install","privacy":"privacy","tos":"tos","i-AndroidChrome":"i-AndroidChrome","i-AndroidChromeNoSW":"i-AndroidChromeNoSW","i-AndroidFirefox":"i-AndroidFirefox","i-AndroidOther":"i-AndroidOther","i-AndroidSamsung":"i-AndroidSamsung","i-IOSOther":"i-IOSOther","i-IOSSafari":"i-IOSSafari","i-IOSSafariNoSW":"i-IOSSafariNoSW","i-OtherMobile":"i-OtherMobile","i-PromptInstall":"i-PromptInstall","i-WebDefault":"i-WebDefault"}[chunkId]||chunkId) + "." + {"admin~app-category~layoutApp":"7f4a35e3","admin~app-premium~auth":"5d4e226d","admin":"86fb599e","app-category":"dddadc97","layoutApp":"3ddf32d1","app-premium":"2b93c66f","auth":"c1fd653c","app-about":"e271f226","app-card":"f5e65dd4","app-contact":"f753d722","app-container":"234ca406","app-getstarted":"79d7216f","app-helphome":"a68aa80b","app-home":"21b5f7f3","install":"500351e0","privacy":"15cb56cc","tos":"379d5811","i-AndroidChrome":"7ebae8ca","i-AndroidChromeNoSW":"28e63ab6","i-AndroidFirefox":"1468e531","i-AndroidOther":"2c5880f2","i-AndroidSamsung":"c7ff571a","i-IOSOther":"8bde32eb","i-IOSSafari":"7bc02856","i-IOSSafariNoSW":"d05d1b68","i-OtherMobile":"ec230c96","i-PromptInstall":"26060da1","i-WebDefault":"a1b06039"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"admin~app-category~layoutApp":1,"admin~app-premium~auth":1,"admin":1,"app-category":1,"layoutApp":1,"app-premium":1,"auth":1,"app-about":1,"app-card":1,"app-contact":1,"app-container":1,"app-getstarted":1,"app-helphome":1,"app-home":1,"install":1,"privacy":1,"tos":1,"i-AndroidChrome":1,"i-AndroidChromeNoSW":1,"i-AndroidFirefox":1,"i-AndroidOther":1,"i-AndroidSamsung":1,"i-IOSOther":1,"i-IOSSafari":1,"i-IOSSafariNoSW":1,"i-OtherMobile":1,"i-PromptInstall":1,"i-WebDefault":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"admin~app-category~layoutApp":"admin~app-category~layoutApp","admin~app-premium~auth":"admin~app-premium~auth","admin":"admin","app-category":"app-category","layoutApp":"layoutApp","app-premium":"app-premium","auth":"auth","app-about":"app-about","app-card":"app-card","app-contact":"app-contact","app-container":"app-container","app-getstarted":"app-getstarted","app-helphome":"app-helphome","app-home":"app-home","install":"install","privacy":"privacy","tos":"tos","i-AndroidChrome":"i-AndroidChrome","i-AndroidChromeNoSW":"i-AndroidChromeNoSW","i-AndroidFirefox":"i-AndroidFirefox","i-AndroidOther":"i-AndroidOther","i-AndroidSamsung":"i-AndroidSamsung","i-IOSOther":"i-IOSOther","i-IOSSafari":"i-IOSSafari","i-IOSSafariNoSW":"i-IOSSafariNoSW","i-OtherMobile":"i-OtherMobile","i-PromptInstall":"i-PromptInstall","i-WebDefault":"i-WebDefault"}[chunkId]||chunkId) + "." + {"admin~app-category~layoutApp":"29cb93a5","admin~app-premium~auth":"fd930ca6","admin":"0b6da221","app-category":"f4a96a9a","layoutApp":"fa39a278","app-premium":"921afc9a","auth":"c40396c5","app-about":"cb4e2bb3","app-card":"e5b33208","app-contact":"a34cb291","app-container":"49095a4f","app-getstarted":"5f277de2","app-helphome":"35715732","app-home":"95ddbce1","install":"3a6409dc","privacy":"c9812626","tos":"c9812626","i-AndroidChrome":"bafb09bf","i-AndroidChromeNoSW":"a7ca2724","i-AndroidFirefox":"9fdf95ed","i-AndroidOther":"992d3be8","i-AndroidSamsung":"372cadec","i-IOSOther":"1ed314b8","i-IOSSafari":"ab0f3031","i-IOSSafariNoSW":"2b6c8eb8","i-OtherMobile":"49b6feb4","i-PromptInstall":"cb4c1c28","i-WebDefault":"d1f20096"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	var startupResult = (function() {
 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
 	})();

 	webpackJsonpCallback([[], {}, 0, ["admin~app-category~layoutApp","layoutApp","install"]]);
 	return startupResult;
